import { NAMESPACE } from 'react/api/actions/base';

export const actions = {
  addToast: `${NAMESPACE}_ADD_TOAST`,
  removeToast: `${NAMESPACE}_REMOVE_TOAST`
};

export const actionCreators = {
  addToast: (payload) => ({ type: actions.addToast, payload }),
  removeToast: (payload) => ({ type: actions.removeToast, payload })
};

export default {
  actions,
  actionCreators
};
